<template>
  <div class="sidebar hidden-print">
    <nav class="sidebar-nav">
      <ul class="nav">
        <template v-if="isTeam(user)">
          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'DASHBOARD_READ')"
              :to="'/dashboard'"
              class="nav-link"
              ><i class="icon-speedometer"></i> Dashboard</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'CLIENTS_READ')"
              :to="'/clients'"
              class="nav-link"
              ><i class="icon-people"></i> Clients</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'COMPANIES_MENU_READ')"
              :to="'/b2b'"
              class="nav-link"
              ><i class="icon-briefcase"></i> Entreprises</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'USERS_MENU_READ')"
              :to="'/users'"
              class="nav-link"
              ><i class="icon-user"></i> Prestataires</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'ATTRIBUTIONS_READ')"
              :to="'/attributions'"
              class="nav-link"
              ><i class="icon-target"></i> Attributions</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'CONVERSION_READ')"
              :to="'/conversion'"
              class="nav-link"
              ><i class="icon-trophy"></i> Conversion</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'FIDELISATION_READ')"
              :to="'/fidelisation'"
              class="nav-link"
              ><i class="icon-action-redo"></i> Fidélisation</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'SESSION_SCHEDULE_TRACKING_READ')"
              :to="'/session-schedule-tracking'"
              class="nav-link"
              ><i class="icon-energy"></i> Planification</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'B2B_TRACKING_READ')"
              :to="'/b2b-tracking'"
              class="nav-link"
              ><i class="icon-arrow-up-circle"></i> Suivi B2B</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'ORDERS_READ')"
              :to="'/orders'"
              class="nav-link"
              ><i class="icon-basket"></i> Commandes</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'BILLING_READ')"
              :to="'/billing'"
              class="nav-link"
              ><i class="icon-doc"></i> Facturation</router-link
            >
          </li>

          <hr class="w-100" />

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'COACH_MANAGER_READ')"
              :to="'/coach-manager'"
              class="nav-link"
              ><i class="icon-badge"></i> Statistiques Coach</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'STATS_READ')"
              :to="'/stats'"
              class="nav-link"
              ><i class="icon-graph"></i> Statistiques Ventes</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'IMPORT_WRITE')"
              :to="'/import'"
              class="nav-link"
              ><i class="icon-disc"></i> Import</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'EXPORT_READ')"
              :to="'/export'"
              class="nav-link"
              ><i class="icon-rocket"></i> Export</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'CONTENTS_READ')"
              :to="'/contents'"
              class="nav-link"
              ><i class="icon-notebook"></i> Contenus</router-link
            >
          </li>

          <li class="nav-item">
            <router-link
              v-if="hasPermission(user, 'SETTINGS_READ')"
              :to="'/settings'"
              class="nav-link"
              ><i class="icon-settings"></i> Paramètres</router-link
            >
          </li>
        </template>
      </ul>

      <div v-if="isTeam(user)">
        <hr class="w-100" />

        <a href="https://manager.justcoaching.dev" class="nav-link">
          Manager de test
        </a>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "sidebar",
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    },
  },
};
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}
</style>
